export default __webpack_public_path__ + "static/media/png-logo.5b590273.png";